const numberingSchemes = {
    PER_SCORABLE_ITEM: 'perScorableItem',
    SECTION_ALPHA_NUMERIC: 'sectionAlphaNumeric',
    SECTION_NUMERIC: 'sectionNumeric',
    TEST_SEQUENTIAL: 'testSequential',
};

export default numberingSchemes;
